import Vue from 'vue'
import QuotaApi from 'api/quota'
import bus from '@/utils/bus'

const QUOTA_INDEX = 'QUOTA_INDEX'
const QUOTA_CLEAN = 'QUOTA_CLEAN'
// initial state
const state = {
  summary: {},
  list: [],
  'permanent_quota_expired': false
}

const getters = {
  overdate: state => {
    return state.permanent_quota_expired
  }
}

const mutations = {
  [QUOTA_INDEX](state, { summary, list, permanent_quota_expired }) {
    // check if quota is updated
    if (state.summary.permanents_left !== null && (summary.permanents_left === null || (state.summary.permanents_left || 0) < summary.permanents_left)) {
      bus.$emit('GetPermanentsQuota', summary.permanents_left === null ? null : summary.permanents_left - state.summary.permanents_left)
    }
    Vue.set(state, 'summary', summary)
    Vue.set(state, 'list', list)
    Vue.set(state, 'permanent_quota_expired', permanent_quota_expired)
  },

  [QUOTA_CLEAN](state) {
    Vue.set(state, 'summary', {})
    Vue.set(state, 'list', [])
    Vue.set(state, 'permanent_quota_expired', false)
  }
}

// actions
const actions = {
  // get a bunch of medias
  index({ rootGetters, commit, state }, params = {}) {
    let _force = params.force || false

    return new Promise((resolve, reject) => {
      if (state.summary.permanents && !_force) {
        resolve(JSON.parse(JSON.stringify(state)))
      } else {
        QuotaApi.index({
          organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
        }).then(res => {
          commit(QUOTA_INDEX, res.data)
          resolve(res.data)
        }).catch(reject)
      }
    })
  },

  // buy quota
  buy({ rootGetters, state }, params) {
    return QuotaApi.buy(Object.assign({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }))
  },

  // consume quota
  consume({ dispatch }, params) {
    return QuotaApi.consume(params).then(_ => {
      dispatch('index', { force: true })
    })
  },

  // check price
  price(_, params) {
    return QuotaApi.price(params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/quota.js